import { FC } from "react";
import { ShoppingBag, Sparkles } from "lucide-react";

export const HeroSection: FC = () => {
  return (
    <section className="container mx-auto px-4 py-12 md:py-20 flex flex-col items-center text-center animate-fade-up">
      <div className="text-6xl md:text-8xl mb-8 transform hover:scale-110 transition-transform duration-300 cursor-pointer space-y-4">
        <div className="flex justify-center items-center gap-4">
          <span className="animate-bounce">🛍️</span>
          <ShoppingBag className="w-24 h-24 text-primary animate-pulse" />
          <span className="animate-bounce">💫</span>
        </div>
      </div>
      <div className="relative">
        <h1 className="text-4xl md:text-7xl font-black mb-6 bg-gradient-to-r from-[#8B5CF6] via-[#D946EF] to-[#8B5CF6] bg-clip-text text-transparent drop-shadow-xl animate-text tracking-normal">
          Selamat Datang di jual.in
        </h1>
        <div className="absolute inset-0 blur-xl opacity-30 bg-gradient-to-r from-[#8B5CF6] via-[#D946EF] to-[#8B5CF6] -z-10"></div>
      </div>
      <p className="text-xl md:text-2xl text-gray-600 dark:text-gray-300 mb-8 max-w-3xl leading-relaxed">
        Satu link satu produk{" "}
        <span className="font-bold text-primary inline-flex items-center">
          gratis <Sparkles className="w-5 h-5 ml-1" />
        </span>
      </p>
      <p className="text-lg text-gray-500 dark:text-gray-400 max-w-2xl">
        Fokuskan promosi produk Anda dengan link khusus untuk setiap produk. Share link yang berbeda untuk produk yang berbeda, sehingga calon pembeli lebih fokus pada produk yang mereka minati.
      </p>
    </section>
  );
};